import React, { Fragment, useState, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

import Dialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import axios from "axios";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import Slide from "@material-ui/core/Slide";
import { Cancel } from "@material-ui/icons";

import LoadClase from "components/services/LoadClase";
import LoadParentesco from "components/services/LoadParentesco";

import { cardBodyStyle } from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function EditPersonal(props) {
  const classes = useStyles();

  const data = props.id;
  const [returnLogin, setReturnLogin] = React.useState(false);

  const [openAlert, setOpenAlert] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");
  const [errorServer, setErrorServer] = useState(false);

  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  const [values, setValues] = useState({
    id: data.id,
    certificado: data.certificado,
    poliza_n: data.poliza_n,
    cedula: data.cedula,
    nombres: data.nombres,
    //apellidos: data.apellidos,
    clase_id: data.clase_id,
    clasedata: { id: data.clase_id, name: data.clasename },
    parentesco_id: data.parentesco_id,
    parentescodata: { id: data.parentesco_id, name: data.parentesconame },
    email_personal: data.correo_electronico,
    celular: data.celular,
    fecha_inclusion: data.fecha_inclusion,
    fecha_nacimiento: data.fecha_nacimiento,
    errorCertificado: false,
    errorPoliza: false,
    errorNombres: false,
    //errorApellidos: false,
    errorCedula: false,
    errorFechaInclusion: false,
    errorFechaNacimiento: false,
    errorParentesco: false,
    errorClase: false,
  });

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
      errorCertificado: false,
      errorPoliza: false,
      errorNombres: false,
      // errorApellidos: false,
      errorCedula: false,
    });
    setOpenAlert(false);
  };

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  const submitForm = (e) => {
    e.preventDefault();
    setOpenAlert(false);
    setErrorServer(false);

    if (values.nombres.length === 0) {
      setValues({ ...values, errorNombres: true });
      setMensaje('El campo "Nombres" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } /* else if (values.apellidos.length === 0) {
      setValues({ ...values, errorApellidos: true });
      setMensaje('El campo "Apellidos" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    }*/ else if (values.fecha_inclusion.length === 0) {
      setValues({ ...values, errorFechaInclusion: true });
      setMensaje('El campo "Fecha de inclusión" es obligatoria.');
      setOpenAlert(true);
      setError("error");
    } else if (values.clase_id.length === 0) {
      setValues({ ...values, errorClase: true });
      setMensaje('El campo "Clase" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } else if (values.fecha_nacimiento === "") {
      setValues({ ...values, errorFechaNacimiento: true });
      setMensaje('El campo "Fecha de nacimiento" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } else if (values.parentesco_id.length === 0) {
      setValues({ ...values, errorParentesco: true });
      setMensaje('El campo "Parentesco" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } else if (values.certificado.length === 0) {
      setValues({ ...values, errorCertificado: true });
      setMensaje('El campo "Certificado" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } else if (values.poliza_n.length === 0) {
      setValues({ ...values, errorPoliza: true });
      setMensaje('El campo "Póliza" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } else if (
      values.cedula.length === 0 &&
      parseInt(values.parentesco_id) === 1
    ) {
      setValues({ ...values, errorCedula: true });
      setMensaje('El campo "Cédula" es obligatoria al titular.');
      setOpenAlert(true);
      setError("error");
    } else {
      const dataValue2 = {
        id: values.id,
        poliza_n: values.poliza_n,
        cedula: values.cedula,
        certificado: values.certificado,
        clase_id: values.clase_id,
        nombres: values.nombres,
        // apellidos: values.apellidos,
        celular: values.celular,
        correo_electronico: values.email_personal,
        parentesco_id: values.parentesco_id,
        fecha_nacimiento: values.fecha_nacimiento,
        fecha_inclusion: values.fecha_inclusion,
        keyAplication: keyAplication,
      };

      axios
        .post(`${urlServices}routes_personalupdate.php`, dataValue2, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.data.code === 1) {
            setMensaje("Modificado con exito.");
            setOpenAlert(true);
            setError("success");
            props.callBackRefresh();
          } else if (response.data.code === 0) {
            setMensaje("Error al modificar.");
            setOpenAlert(true);
            setError("error");
          }
        })
        .catch((e) => {
          if (e.response.status === 401) {
            setTimeout(() => {
              localStorage.clear();
              setReturnLogin(true);
            }, 200);
          } else {
            setErrorServer(true);
          }
        });
    }
  };

  const handleDateNacimientoChange = (e) => {
    setValues({
      ...values,
      fecha_nacimiento: e.target.value,
      errorFechaNacimiento: false,
    });
  };

  const handleDateInclusionChange = (e) => {
    setValues({
      ...values,
      fecha_inclusion: e.target.value,
      errorFechaInclusion: false,
    });
  };

  const changeClase = (data) => {
    setValues({
      ...values,
      clase_id: data !== null ? data.id : "",
      clasedata: data !== null ? data : [],
      errorClase: false,
    });
  };

  const changeParentesco = (data) => {
    setValues({
      ...values,
      parentesco_id: data !== null ? data.id : "",
      parentescodata: data !== null ? data : [],
      errorParentesco: false,
    });
  };

  const handleCedulaChange = (e) => {
    setValues({
      ...values,
      cedula: e.target.value,
      errorCedula: false,
    });
  };

  const changeGender = (data) => {
    setValues({
      ...values,
      gender_id: data !== null ? data.id : "",
      gendername: data !== null ? data.name : "",
      genderdata: data !== null ? data : [],
      errorGender: false,
    });
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="sm"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        style={{ zIndex: 100 }}
        PaperProps={{
          classes: { root: classes.DialogStyle },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container spacing={1} className={classes.containerProfile}>
              <Grid item xs={12} sm={12}>
                {errorServer ? (
                  <Alert severity="error">
                    Error al registrar en el servidor
                  </Alert>
                ) : (
                  ""
                )}
              </Grid>
              <Grid item xs={12} sm={12}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12}>
                    <div className={classes.titleCardFilter}>
                      Editar personal
                    </div>
                    <div className={classes.lineBottom}></div>
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <TextField
                      autoComplete="off"
                      name="nombres"
                      value={values.nombres}
                      onChange={handleChange("nombres")}
                      label="Nombres"
                      error={values.errorNombres}
                      fullWidth
                      required
                    />
                  </Grid>
                  {/* <Grid item xs={12} sm={6}>
                    <TextField
                      autoComplete="off"
                      name="apellidos"
                      value={values.apellidos}
                      onChange={handleChange("apellidos")}
                      label="Apellidos"
                      error={values.errorApellidos}
                      fullWidth
                      required
                    />
                  </Grid>*/}
                  <Grid item xs={12} md={4}>
                    <TextField
                      name="date"
                      label="Fecha de inclusión"
                      type="date"
                      value={values.fecha_inclusion}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => handleDateInclusionChange(e)}
                      autoComplete="off"
                      error={values.errorFechaInclusion}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      autoComplete="off"
                      name="cedula"
                      value={values.cedula}
                      onChange={handleCedulaChange}
                      label="Cédula"
                      error={values.errorCedula}
                      fullWidth
                      required
                      type="number"
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <LoadClase
                      refresh={changeClase}
                      value={values.clasedata}
                      error={values.errorClase}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      autoComplete="off"
                      name="celular"
                      value={values.celular}
                      onChange={handleChange("celular")}
                      label="celular"
                      fullWidth
                      type="number"
                      required
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <LoadParentesco
                      refresh={changeParentesco}
                      value={values.parentescodata}
                      error={values.errorParentesco}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      name="date"
                      label="Fecha nacimiento"
                      type="date"
                      value={values.fecha_nacimiento}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => handleDateNacimientoChange(e)}
                      autoComplete="off"
                      error={values.errorFechaNacimiento}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      autoComplete="off"
                      name="certificado"
                      value={values.certificado}
                      onChange={handleChange("certificado")}
                      label="Certificado"
                      fullWidth
                      required
                      error={values.errorCertificado}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      autoComplete="off"
                      name="email_personal"
                      value={values.email_personal}
                      onChange={handleChange("email_personal")}
                      label="Correo electrónico"
                      fullWidth
                      required
                    />
                  </Grid>                 
                  <Grid item xs={12} sm={4}>
                    <TextField
                      autoComplete="off"
                      name="poliza_n"
                      value={values.poliza_n}
                      onChange={handleChange("poliza_n")}
                      label="Póliza"
                      fullWidth
                      required
                      error={values.errorPoliza}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <br></br>
                    <center>
                      <Button
                        type="submit"
                        className={classes.buttonSubmit}
                        onClick={submitForm}
                      >
                        Guardar
                      </Button>
                    </center>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Snackbar
              open={openAlert}
              autoHideDuration={6000}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              onClose={handleClose}
            >
              <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
                <Alert
                  onClose={handleClose}
                  severity={error === "error" ? "error" : "success"}
                  elevation={6}
                  variant="filled"
                >
                  {mensaje}
                </Alert>
              </Slide>
            </Snackbar>
          </Fragment>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog(true)}>
            <Cancel />
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
